/*
  Cart fix for apex-core.js CartForm (load this script before apex-core.js)
  - Skips the initial /cart?view=ajax request when the cart is empty on page load
    (that request returns the full cart page without any cart items)
  - Stops cartMarkup from throwing when the response has no .cart__items element
*/
(function() {
  window.apx = window.apx || {};

  var script = document.currentScript;
  var initialCount = script ? parseInt(script.getAttribute('data-cart-count') || '', 10) : NaN;
  var skipInitialBuild = initialCount === 0;

  function patch(CartForm) {
    if (!CartForm || !CartForm.prototype || CartForm.prototype.__amzCartFix) return;
    var proto = CartForm.prototype;
    var originalBuildCart = proto.apxBuildCart;
    var originalCartMarkup = proto.cartMarkup;

    proto.apxBuildCart = function() {
      if (skipInitialBuild) {
        skipInitialBuild = false;
        return;
      }
      return originalBuildCart.apply(this, arguments);
    };

    proto.cartMarkup = function(text) {
      if (typeof text !== 'string') return;
      var markup = this._parseProductHTML(text);
      if (!markup || !markup.items) return;
      return originalCartMarkup.apply(this, arguments);
    };

    proto.__amzCartFix = true;
  }

  // apex-core.js assigns apx.CartForm while it runs; patch it at that moment
  var cartFormValue = apx.CartForm;
  if (cartFormValue) {
    patch(cartFormValue);
  } else {
    try {
      Object.defineProperty(apx, 'CartForm', {
        configurable: true,
        enumerable: true,
        get: function() { return cartFormValue; },
        set: function(value) {
          patch(value);
          cartFormValue = value;
        }
      });
    } catch (e) {}
  }

  // Any cart change after load must always rebuild
  ['ajaxProduct:added', 'cart:updated', 'cart:change'].forEach(function(name) {
    document.addEventListener(name, function() { skipInitialBuild = false; }, true);
  });
})();
